/**
 * ป้ายสังหาร marks over heads (systems/guildBanner.ts `markOf`): a small pixel pennant over the members of the guild
 * our banner hunts (red, 殺) and over hunters of a banner raised against us (ink, 令). FX pixel rules: whole art pixels,
 * a 1-px dark outline, flat colours, no glow. Reads the World; decides no rule.
 */
import { GUILD_BANNER_MARKS } from '@nine/shared';
import { hidden } from '../drawKit';
import { globeBend } from '../globe';
import { UI } from '../labels';
import { visualScale } from '../sprites';
import { registerRenderPass } from './registry';

const OUTLINE = '#120c0a';
const POLE = '#c79a2b';

registerRenderPass({
  id: 'guildBannerMark',
  layer: 'labels',
  order: 104, // 105 is lockBody (registry throws on a clash; this blacked out the 10-14 deploy)
  draw(f) {
    const { mg, world: w, px: PX, effects: fx, sprites, iso, ox, oy } = f;
    const sys = w.sys.guildBanner;
    if (!w.progress.guild) return;
    for (const e of f.shown()) {
      if ((e.kind !== 'player' && e.kind !== 'rival') || e.dead || hidden(e)) continue;
      const mark = sys.markOf(e);
      if (!mark) continue;
      const set = sprites.of(e);
      if (!set) continue;
      const [sx, sy] = iso.proj(e.x, e.y);
      const ax = Math.round(sx + ox);
      const top = globeBend(sx + ox, sy + oy - e.z - fx.hoverOf(e) - fx.anim(e.id).elev - set.h * visualScale(e, set) - 3)[1];
      // art pixels: the pennant stands above the title plate
      const ay = Math.round(top - 20);
      const m = GUILD_BANNER_MARKS[mark];
      mg.save();
      mg.scale(PX, PX);
      mg.imageSmoothingEnabled = false;
      // pole
      mg.fillStyle = OUTLINE;
      mg.fillRect(ax - 6, ay - 1, 3, 13);
      mg.fillStyle = POLE;
      mg.fillRect(ax - 5, ay, 1, 11);
      // flag: a 10×8 cloth with a notched tail, outlined
      mg.fillStyle = OUTLINE;
      mg.fillRect(ax - 4, ay - 1, 12, 10);
      mg.fillStyle = m.color;
      mg.fillRect(ax - 4, ay, 11, 8);
      mg.fillStyle = OUTLINE;
      mg.fillRect(ax + 6, ay + 3, 2, 2);
      mg.fillStyle = 'rgba(255,255,255,.18)';
      mg.fillRect(ax - 4, ay, 11, 1);
      mg.fillStyle = '#f4f1ea';
      mg.font = `700 7px ${UI}`;
      mg.textAlign = 'center';
      mg.textBaseline = 'middle';
      mg.fillText(m.glyph, ax + 1, ay + 4.5);
      mg.restore();
    }
  },
});
